import * as React from "react";
import { RouteComponentProps } from "@reach/router";

import { FormikProps } from "formik";
import { cx, css } from "@emotion/css";
import { navigate } from "../support/hashRouting";
import { FormValues } from "../support/FormValues";
import { StepHeader } from "../components/StepHeader";

import bootstrapStyles from "../css/bootstrap.module.css";
import Breadcrumbs from "../components/Breadcrumbs";
import ReviewTransferInformation from "./Review/ReviewTransferInformation";
import ReviewPersonalInformation from "./Review/ReviewPersonalInformation";
import ReviewFundSelection from "./Review/ReviewFundSelection";
import { GeneralButton } from "../components/GeneralButton";
import { useScrollTop } from "../customHooks/scrollTop";

interface ReviewProps extends RouteComponentProps {
  formikBag: FormikProps<FormValues>;
}

const Review = ({
  formikBag: { values },
  formikBag,
  location
}: ReviewProps) => {
  useScrollTop(location);

  const stepHeaderText = `Great work, ${values.firstName}! Here's what we've captured.`;
  const stepNote = `Please review your information.`;
  return (
    <div>
      <Breadcrumbs currentStep={4} />
      <div className={bootstrapStyles.row}>
        <div className={cx(bootstrapStyles["col-md-12"])}>
          <StepHeader stepHeader={stepHeaderText} stepNote={stepNote} />
        </div>
      </div>
      <ReviewTransferInformation formikBag={formikBag} />
      <ReviewPersonalInformation formikBag={formikBag} />
      <ReviewFundSelection formikBag={formikBag} />

      <div className={bootstrapStyles.row}>
        <div
          className={bootstrapStyles["col-md-12"]}
          style={{ marginTop: "32px" }}
        >
          <hr />
        </div>
      </div>

      <div className={bootstrapStyles.row}>
        <div className={cx(bootstrapStyles["col-md-12"])}>
          <GeneralButton
            id="back"
            text="back"
            buttonType="secondary"
            onClick={() => {
              navigate("/fundSelection");
            }}
          />
          <div
            className={css`
              float: right;
            `}
          >
            <GeneralButton
              id="continue"
              text="continue"
              onClick={() => {
                navigate("/sign");
              }}
              buttonType="primary"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Review;
